module.exports = __webpack_public_path__ + "static/media/ae.824d8671.svg";